import styled from "styled-components";

export const OurMissionStyle = styled.article`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;

  @media(max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;


